// @flow
import React, { PureComponent, type AbstractComponent } from 'react';
import BrowserExtension from 'app/common/lib/BrowserExtension';
import PropTypes from 'prop-types';
import { NUX_BROWSER_EXT_INSTALLLED_CHECK_DELAY } from 'app/common/react/components/growth/activation/NuxConst/NuxConst';

type Props = {
  steps: Array<{
    moduleName: string,
    options?: Object,
  }>,
};

type State = {
  skipExtStep: boolean,
};

export default function withFilteredNuxSteps<P: Props>(
  Subject: AbstractComponent<P>,
): AbstractComponent<P> {
  class FilteredNuxSteps extends PureComponent<P, State> {
    static propTypes = {
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          moduleName: PropTypes.string.isRequired,
          options: PropTypes.shape({}),
        }),
      ).isRequired,
    };

    state: State = {
      skipExtStep: false,
    };

    componentDidMount() {
      const { steps } = this.props;
      BrowserExtension.extensionReady(NUX_BROWSER_EXT_INSTALLLED_CHECK_DELAY).then(
        (isExtInstalled) => {
          // Don't bother updating state unless it's possible to skip it.
          // The backend should prevent NuxExtensionUpsell from being a step unless
          // this is a cookieless first load.
          const hasExtStep = steps.some((step) => step.moduleName === 'NuxExtensionUpsell');
          if (hasExtStep && isExtInstalled) {
            this.setState({ skipExtStep: true });
          }
        },
      );
    }

    render() {
      let { steps } = this.props;
      const { skipExtStep } = this.state;
      if (skipExtStep) {
        steps = steps.filter((step) => step.moduleName !== 'NuxExtensionUpsell');
      }

      return <Subject {...this.props} steps={steps} />;
    }
  }

  return FilteredNuxSteps;
}
